<template>
    <div class="login-container" :style="portalStyles">
        <div class="login-right" :class="{ 'has-background': portalConfig.background_image }">
            <!-- LOGO显示 -->
            <div v-if="portalConfig.logo" class="portal-logo">
                <img :src="portalConfig.logo" alt="Logo" />
            </div>

            <!-- 标题显示 -->
            <h1 class="portal-title">{{ portalConfig.name }}</h1>
        </div>

        <div class="login-left" style="position: relative;">
            <!-- LOGO显示在左上角 -->


            <div class="form-container">
                <h2>Reset Password</h2>
                <p class="or-text">Enter your new password below</p>

                <!-- 隐藏的 token 和 email 字段 -->
                <el-input v-model="form.token" type="hidden" />
                <el-input class="brim" v-model="form.email" placeholder="New Email" prefix-icon="el-icon-message" />

                <!-- 用户输入的密码和确认密码 -->
                <el-input class="brim" v-model="form.password" placeholder="New Password" prefix-icon="el-icon-lock"
                    show-password />
                <el-input class="brim" v-model="form.password_confirmation" placeholder="Confirm Password"
                    prefix-icon="el-icon-lock" show-password />

                <el-button type="primary" class="login-btn themed-button" :disabled="!canSubmit"
                    @click="resetPasswordEvent">
                    Reset Password
                </el-button>

                <div class="signup-link">
                    Remembered your password?
                    <span @click="goToLogin" class="themed-link-span">Go to Login</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resetPassword } from "@/api/auth";
import CryptoJS from "crypto-js";  // 引入 CryptoJS 用于加密
import { portalConfigMixin } from "@/mixins/portalConfig"; // 引入混入

export default {
    name: "ResetPasswordmodule",
    mixins: [portalConfigMixin], // 使用混入
    data() {
        return {
            form: {
                token: "",
                email: "",
                password: "",
                password_confirmation: "",
            }
        };
    },

    computed: {
        canSubmit() {
            return this.form.password && this.form.password_confirmation && this.form.password === this.form.password_confirmation;
        }
    },

    created() {
        // 获取 URL 中的查询参数
        const params = new URLSearchParams(window.location.search);

        // 获取 token 和 email 参数，如果没有则返回空字符串
        this.form.token = params.get("token") || "";
        this.form.email = params.get("email") || "";
        console.log(this.form.token, this.form.email);

        // 如果没有 token 或 email，则提示错误并跳转回忘记密码页面
        if (!this.form.token || !this.form.email) {
            this.$message.error("Invalid reset link.");
            this.$router.push("/forgot_password");
        }
    },

    mounted() {
        const workspaceId = localStorage.getItem("workspaceId");
        if (!workspaceId) {
            window.location.href = "https://lazifunnel.com";
        }
    },

    methods: {
        async resetPasswordEvent() {
            if (!this.canSubmit) {
                this.$message.error("Passwords do not match!");
                return;
            }

            // 使用 CryptoJS 对密码和确认密码进行加密
            const encryptedPassword = CryptoJS.SHA256(this.form.password).toString();
            const encryptedPasswordConfirmation = CryptoJS.SHA256(this.form.password_confirmation).toString();

            // 提交包含加密后的密码、token 和 email 的表单数据
            try {
                const res = await resetPassword({
                    ...this.form,
                    password: encryptedPassword,  // 使用加密后的密码
                    password_confirmation: encryptedPasswordConfirmation  // 使用加密后的确认密码
                });

                if (res.success) {
                    this.$message.success("Password reset successful!");
                    this.goToLogin();
                }
            } catch (error) {
                console.error(error);
            }
        },

        goToLogin() {
            this.$router.push({ path: "/sign_in" });
        }
    }
};
</script>

<style scoped>
@import "@/assets/css/auth.css";

/* 使用CSS变量应用主题色 */
.login-container {
    --theme-color: #007bff;
    --background-image: none;
}

/* 左侧LOGO样式 - 左上角显示 */




/* 右侧背景区域 */
.login-right {
    background-color: var(--theme-color);
    background-image: var(--background-image);
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-right.has-background {
    background-color: transparent;
}

/* LOGO样式 */
.portal-logo {
    margin-bottom: 20px;

}

.portal-logo img {
    max-width: 150px;
    max-height: 80px;
    object-fit: contain;
}

/* 标题样式 */
.portal-title {
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-align: center;
    margin: 0;
}

/* 主题按钮样式 */
.themed-button {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
}

.themed-button:hover {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
    opacity: 0.8;
}

/* 主题链接样式 */
.themed-link-span {
    color: var(--theme-color);
    cursor: pointer;
}

.themed-link-span:hover {
    opacity: 0.8;
}

/* 通用样式 */
.or-text {
    text-align: center;
    margin: 20px 0;
}

.login-btn {
    width: 100%;
    margin-top: 20px;
}

.signup-link {
    text-align: center;
    margin-top: 15px;
}

.brim {
    margin-bottom: 10px;
}
</style>